import React, { Component } from 'react';
import { Grid, Header } from 'semantic-ui-react';
import CustomRadioButtonV1 from '../../../app/common/Form/CustomRadioBtnV1';
import Account from '../../bankAccounts/Account';
import NoAccounts from '../../bankAccounts/NoAccounts';

export default class BankSingleOptionRow extends Component {
    selectAccount = account => {
        const { selectAccount } = this.props;

        if (typeof selectAccount === 'function') selectAccount(account);
    }
    render() {
        const { bank, selectedAccount } = this.props;

        const bankData = bank && bank.get && bank.get.data;
        const bankDataIsArr = bankData && Array.isArray(bankData);

        let content = (
            <NoAccounts message="You don't have any bank accounts yet." />
        );

        if (bankDataIsArr && bankData.length > 0) {
            content = bank.get.data.map(account => {
                return (
                    <Grid.Row onClick={e => {
                        e.stopPropagation();
                        this.selectAccount(account);
                    }} key={account.accountToken} style={{ cursor: 'pointer' }}>
                        <Grid.Column width={1}>
                            <div style={{ marginTop: '20px' }}>
                                {
                                    <CustomRadioButtonV1
                                        checked={selectedAccount && account && selectedAccount.accountToken === account.accountToken}
                                    />
                                }
                            </div>
                        </Grid.Column>

                        <Grid.Column width={2}></Grid.Column>

                        <Grid.Column width={12}>
                            <Account
                                account={account}
                                customClass="account"
                                clickable={false}
                                border={false}
                            />
                        </Grid.Column>
                    </Grid.Row>
                );
            });
        } else if (bankData && bankData.errorMessage) {
            content = (
                <div id="feature-bank-accounts">
                    <Header as="h1">Bank Accounts</Header>
                    <NoAccounts
                        message="API Error, Unable to fetch bank account(s)!"
                        error
                    />
                </div>
            );
        }

        return (
            <>
                {content}
            </>
        )
    }
}
